"use strict";

exports.__esModule = true;
var driftTypes_1 = require("./utils/driftTypes");
var conversationsWeb_1 = require("./appConfigs/conversationsWeb");
var settingsWeb_1 = require("./appConfigs/settingsWeb");
var trafficControl_1 = require("./appConfigs/trafficControl");
var insightsWeb_1 = require("./appConfigs/insightsWeb");
var contactsWeb_1 = require("./appConfigs/contactsWeb");
var marketplaceWeb_1 = require("./appConfigs/marketplaceWeb");
var conversationsDesktop_1 = require("./appConfigs/conversationsDesktop");
var generateAppConfig = function (user, app, userProperties) {
  if (userProperties === void 0) {
    userProperties = {};
  }
  switch (app) {
    case driftTypes_1.DriftAppsIF.conversationsWeb:
      return conversationsWeb_1["default"](user);
    case driftTypes_1.DriftAppsIF.settingsWeb:
      return settingsWeb_1["default"](user, userProperties);
    case driftTypes_1.DriftAppsIF.trafficControl:
      return trafficControl_1["default"](user);
    case driftTypes_1.DriftAppsIF.insightsWeb:
      return insightsWeb_1["default"](user);
    case driftTypes_1.DriftAppsIF.contactsWeb:
      return contactsWeb_1["default"](user);
    case driftTypes_1.DriftAppsIF.conversationsDesktop:
      return conversationsDesktop_1["default"](user);
    default:
      throw new Error('need to pass in a valid app');
  }
};
var generateAppConfigForOrg = function (org, app) {
  switch (app) {
    case driftTypes_1.DriftAppsIF.marketplaceWeb:
      return marketplaceWeb_1["default"](org);
    default:
      throw new Error('need to pass in a valid app');
  }
};
exports.generateConversationsWebAppConfig = function (user) {
  return generateAppConfig(user, driftTypes_1.DriftAppsIF.conversationsWeb);
};
exports.generateSettingsWebAppConfig = function (user, userProperties) {
  if (userProperties === void 0) {
    userProperties = {};
  }
  return generateAppConfig(user, driftTypes_1.DriftAppsIF.settingsWeb, userProperties);
};
exports.generateTrafficControlNavConfig = function (user) {
  return generateAppConfig(user, driftTypes_1.DriftAppsIF.trafficControl);
};
exports.generateInsightsWebAppConfig = function (user) {
  return generateAppConfig(user, driftTypes_1.DriftAppsIF.insightsWeb);
};
exports.generateContactsWebAppConfig = function (user) {
  return generateAppConfig(user, driftTypes_1.DriftAppsIF.contactsWeb);
};
exports.generateMarketplaceWebAppConfig = function (org) {
  return generateAppConfigForOrg(org, driftTypes_1.DriftAppsIF.marketplaceWeb);
};
exports.generateConversationsDesktopAppConfig = function (user) {
  return generateAppConfig(user, driftTypes_1.DriftAppsIF.conversationsDesktop);
};
exports["default"] = generateAppConfig;